import React, { useEffect, useState } from "react";
// import "./domain.css";
import axios from "axios";
// import moment from "moment";
// import Modal from "react-bootstrap/Modal";
import { Box } from "./sitemapStyle";
import { isInIframe } from "../../utils/is-in-iframe";
import { ToolsHeader } from "../components/ToolsHeader";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";

interface ApiResponse {
  success: boolean;
  message: string;
  data: string;
}
const SitemapChecker: React.FC = () => {
  const [domainName, setDomainName] = useState("");
  const [domainInfo, setDomainInfo] = useState<{
    hostname: string;
    sitemapLink: string;
    xmlLinks: string[];
  } | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  //   const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ type: "setHeight", height }, "*");
  }, [error, domainInfo]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setError("");
      setDomainInfo(null);
      let domainHttp = domainName.trim();
      if (!/^https?:\/\//i.test(domainHttp)) {
        domainHttp = `https://${domainHttp}`;
      }
      if (!validateUrl(domainHttp)) {
        setError("Please enter a valid URL including http:// or https://");
        return;
      }
      setLoading(true);

      const { hostname } = new URL(domainHttp);
      const baseUrl = process.env.REACT_APP_BASE_API;
      const response: any = await axios.get<ApiResponse>(
        `${baseUrl}/api/site-map/sitemap-checker/${hostname}`
      );

      if (response.status !== 200) {
        setLoading(false);
        return;
      }
      if (response?.data?.success && response?.data?.data?.length > 0) {
        const setData = {
          hostname: hostname,
          sitemapLink: `https://${hostname}/sitemap.xml`,
          xmlLinks: response?.data?.data,
        };
        setDomainInfo(setData);
        setLoading(false);
        const height = document.body.scrollHeight;
        window.parent.postMessage({ type: "setHeight", height }, "*");
      } else if (
        response?.data?.success &&
        response?.data?.data?.length === 0
      ) {
        const setData = {
          hostname: hostname,
          sitemapLink: `https://${hostname}/sitemap.xml`,
          xmlLinks: [],
        };
        setDomainInfo(setData);
        setLoading(false);
        const height = document.body.scrollHeight;
        window.parent.postMessage({ type: "setHeight", height }, "*");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const validateUrl = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };
  return (
    <Box>
      <div
        className={`${!isInIframe ? "py-5 defaultText" : "py-0 interDisplay"}`}
      >
        <div className="container_domain">
          {!isInIframe && (
            <ToolsHeader
              title="Sitemap Checker"
              description={`Enter your website URl below to check if an XML sitemap is available.`}
            />
          )}
          <form className={`${domainInfo && "url-form"}`}>
            <div className="input-group-box">
              <input
                type="text"
                className="input_checker"
                value={domainName}
                onChange={(e) => {
                  setError("");
                  setDomainName(e.target.value);
                }}
                placeholder="Enter URL (e.g., https://example.com)"
                required
              />
              <button
                onClick={handleSubmit}
                type="submit"
                disabled={loading}
                className="checker_button"
              >
                {loading ? "Checking..." : "Check"}
                <span className="spinner hidden"></span>
              </button>
            </div>
            {error && <div className="error-message">{error}</div>}
          </form>
          {domainInfo && (
            <div
              style={{
                maxHeight: "25rem",
                overflow: "auto",
                border: "1px solid #d1d5db",
                padding: "10px",
                textAlign: "center",
                borderRadius: "8px",
              }}
            >
              <div style={{ fontWeight: "700", marginBottom: "0.5rem" }}>
                {domainInfo && domainInfo?.xmlLinks.length === 0
                  ? "your website don't have a sitemap.xml : "
                  : "your website has a sitemap.xml : "}
                <span style={{ color: "#8cc540" }}>
                  {domainInfo?.sitemapLink}
                </span>
                <span style={{ marginLeft: "5px" }}>
                  {domainInfo && domainInfo?.xmlLinks.length > 0 ? (
                    <FaCheck color="#8cc540" />
                  ) : (
                    <ImCross color="#d53e35" />
                  )}
                </span>
              </div>
              {/* {domainInfo && domainInfo?.xmlLinks.length > 0 && (
                <div
                  style={{
                    fontWeight: "700",
                    marginBottom: "0.5rem",
                    color: "#ffa125",
                  }}
                >
                  {`Recommendation it is recommended to add a sitemap index file at https://${domainInfo.hostname}/sitemap_index.xml for better search engine optimization.`}
                </div>
              )} */}
              {domainInfo && domainInfo?.xmlLinks.length > 0 && (
                <div>
                  <div style={{ fontWeight: "700" }}>
                    Your website has the following sitemaps listed in
                    sitemap.xml:
                  </div>
                  {domainInfo?.xmlLinks.map((x, i) => (
                    <div
                      style={{ fontWeight: "700", color: "#8cc540" }}
                      key={i}
                    >
                      {x}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Box>
  );
};

export default SitemapChecker;
